export const ADD_TO_CART_SELECTOR =
  "button[data-action='add-to-cart']" as const;
export const PRICE_SELECTOR = "[data-item-value='price']" as const;
export const PRICE_MARKUP = "{{price}}" as const;
